import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import BaseSlider from 'components/sliders/BaseSlider';
import Container from 'components/Container';
import PersonCard from 'components/cards/entities/PersonCard';
import Section from 'components/Section';

import { PersonType } from 'propTypes/entities';

import { SCREEN_BREAKPOINTS } from 'utils/helpers/constants';

// @TODO: Update slider on new design
const EditorChoice = ({ persons }) => {
	const sliderParams = useMemo(
		() => ({
			slidesPerView: 'auto',
			spaceBetween: 8,
			breakpoints: {
				[SCREEN_BREAKPOINTS.tabletLarge]: {
					slidesPerView: 6,
					spaceBetween: 24
				},
				[SCREEN_BREAKPOINTS.desktopMedium]: {
					slidesPerView: 7,
					spaceBetween: 24
				}
			}
		}),
		[]
	);

	return (
		<Section title="Выбор редакции">
			<Container width="wideSlider">
				<BaseSlider theme="full" params={sliderParams}>
					{persons.map((person) => (
						<PersonCard
							key={person._id}
							entity={person}
							typeWidth="fluidPortraitSlide"
						/>
					))}
				</BaseSlider>
			</Container>
		</Section>
	);
};

EditorChoice.propTypes = {
	persons: PropTypes.arrayOf(PersonType)
};

export default EditorChoice;
